import { VolleyballEventStatusId } from '@collector/sportsapi-client-legacy'

export const VolleyballManualAddStatusIds = [
  VolleyballEventStatusId.FirstSet,
  VolleyballEventStatusId.SecondSet,
  VolleyballEventStatusId.ThirdSet,
  VolleyballEventStatusId.FourthSet,
  VolleyballEventStatusId.FifthSet,
  VolleyballEventStatusId.GoldenSet,
]
